import React, { useRef, useState, useContext } from 'react';
import './index.scss';
import getSiteConfig from '../../../siteConfig';
import { isOnIPhone, setNewsit, setNewsit2, getSITEID } from '@/lib/utils';
import { enterpriseSignUrl } from '@/config/base';
import { RootContext } from '@/container';
var siteConfig = getSiteConfig(process.env.SITE_ID);
var Home = function (props) {
    var _a = useState(), profileUrl = _a[0], setProfileUrl = _a[1];
    var _b = useState(false), dowloading = _b[0], setDownloading = _b[1];
    var _c = useState(false), dowloadActive = _c[0], setDownloadingActive = _c[1];
    var theRef = useRef(null);
    var _d = useState(process.env.SITE_ID), sitid = _d[0], setSitid = _d[1];
    var _e = useContext(RootContext), state = _e.state, baseInfos = _e.baseInfos, dispatch = _e.dispatch;
    var handleScrollDown = function () {
        if (!theRef.current) {
            return;
        }
        var h = theRef.current.offsetHeight;
        if (!h) {
            return;
        }
        window.scrollTo({
            top: h,
            left: 0,
            behavior: 'smooth'
        });
    };
    var handleDownload = function () {
        if (dowloadActive) {
            setTimeout(function () {
                setDownloading(false);
            }, 5000);
            return;
        }
        if (isOnIPhone) {
            // y0,y1 代理app改成企业签，本地写死,不走厚土逻辑
            window.location.href = enterpriseSignUrl[Number(sitid)];
            setDownloading(false);
            return;
        }
        var TySCM_o = window.TySCM_o;
        if (!TySCM_o) {
            setTimeout(function () {
                handleDownload();
                setDownloading(false);
            }, 500);
            return;
        }
        setDownloadingActive(true);
        TySCM_o.wakeupOrInstall(function (url) {
            setProfileUrl(url);
            setTimeout(function () {
                setDownloadingActive(false);
                setDownloading(false);
            }, 5000);
        });
        setTimeout(function () {
            setDownloadingActive(false);
            setDownloading(false);
        }, 5000);
    };
    return (React.createElement("div", { className: setNewsit(sitid) ? "mod-home" + getSITEID(sitid) : 'mod-home', style: {
            height: state.viewHeight
        } },
        React.createElement("div", { ref: theRef },
            setNewsit2(sitid) ? (React.createElement("h1", { style: {
                    color: siteConfig.themeColor
                } },
                React.createElement("img", { src: require("@/assets/img/" + siteConfig.key + ".png"), alt: "" }),
                "\u4EE3\u7406APP")) : null,
            setNewsit2(sitid) ? (React.createElement("div", { className: "image" },
                React.createElement("img", { src: require('@/assets/img/image.png'), alt: "" }))) : null,
            React.createElement("div", { className: setNewsit(sitid) ? '' : 'download' },
                dowloading ? (React.createElement("span", { className: setNewsit(sitid) ? 'loading1001' : 'loading' }, "\u6B63\u5728\u4E0B\u8F7D...")) : (React.createElement("a", { id: "J_download", className: setNewsit(sitid) ? 'downloadbtn' : 'btn', style: {
                        backgroundColor: setNewsit(sitid) ? null : siteConfig.themeColor
                    }, onTouchEnd: function (e) {
                        setDownloading(true);
                        handleDownload();
                    } }, "\u4E0B\u8F7D\u5B89\u88C5")),
                React.createElement("p", { className: "sub1001" }, "\u53F2\u4E0A\u6700\u597D\u7528\u7684\u8D27\u5E01\u6C47\u7387\u6362\u7B97App")),
            isOnIPhone && (React.createElement("div", { className: "pager", onTouchStart: function (e) {
                    e.preventDefault();
                    handleScrollDown();
                }, onClick: function (e) {
                    e.preventDefault();
                    handleScrollDown();
                }, style: {
                    color: siteConfig.themeColor
                } },
                React.createElement("span", null, "\u4E0B\u6ED1\u67E5\u770B\u5B89\u88C5\u6559\u7A0B"),
                React.createElement("span", { className: "arrow" }))))));
};
export default Home;
